export const toCamelCase = (text: string) => {
    if (typeof text === 'string') {
        const camelCaseText = text.toLowerCase().replace(/(?:(^.)|([-_\s]+.))/g, match => {
            return match.charAt(match.length - 1).toUpperCase();
        });

        return camelCaseText.charAt(0).toLowerCase() + camelCaseText.substring(1);
    } else {
        return '';
    }
};
